import { useTheme } from '../context/ThemeContext';
import palette from '../theme/palette.json';
import pitriotLogo from '../assets/pitriot-logo-b64.js';
import logoMask from '../assets/pitriot-logo-mask.png';

/*
 * The PITRIOT wordmark.
 *
 * The artwork is dark ink on white paper, so a dark theme showed it as a white
 * box. There it is drawn instead as an alpha mask cut from the same artwork
 * (src/assets/pitriot-logo-mask.png) and inked with --c-logo-ink: the paper,
 * and the mycelium inside the P, become see-through. Light themes keep the
 * original artwork untouched.
 */
export default function LogoMark({ alt, maxWidth = 320 }) {
  const { theme } = useTheme();

  if (palette.themes[theme]?.scheme === 'dark') {
    const mask = `url(${logoMask}) center / contain no-repeat`;
    return (
      <div
        role="img"
        aria-label={alt}
        data-testid="logo-mark"
        data-variant="mask"
        style={{
          width: '100%', maxWidth, aspectRatio: '800 / 240',
          background: 'var(--c-logo-ink)', WebkitMask: mask, mask,
        }}
      />
    );
  }

  return (
    <img
      src={pitriotLogo}
      alt={alt}
      data-testid="logo-mark"
      data-variant="artwork"
      style={{ width: '100%', maxWidth, height: 'auto', display: 'block' }}
    />
  );
}
